import { render, staticRenderFns } from "./create-admin.vue?vue&type=template&id=54916ea9&scoped=true"
import script from "./create-admin.vue?vue&type=script&lang=js"
export * from "./create-admin.vue?vue&type=script&lang=js"
import style0 from "./create-admin.vue?vue&type=style&index=0&id=54916ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54916ea9",
  null
  
)

export default component.exports